import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import styled from 'styled-components';

export const TransactionsFiltersRow = styled.label<{ checked?: boolean }>`
  ${flex({ flexDirection: 'column', justifyContent: 'center' })}
  padding: 10px 16px;
  height: 44px;

  ${({ checked }) =>
    checked &&
    `
    background: ${COLORS.grey[150]}
  `}
`;
